import React, { useMemo } from 'react';
import Select from '../../../BaseComponents/Select';
import TextInput from '../../../BaseComponents/TextInput';
import LocationButtons from './LocationButtons';
import '../Appointments.scss';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { useFormikContext } from 'formik';
import { LocationType } from '../../../../types/apiGeneratedTypes';
import { FormValues } from './AppointmentModal';

type Props = {
  currentLocationOption: LocationType;
  onLocationBtnClick: (location: LocationType) => void;
  membershipType?: string | null;
  isAppointmentView?: boolean;
};

const AppointmentLocation = ({
  currentLocationOption,
  onLocationBtnClick,
  membershipType,
  isAppointmentView = false
}: Props) => {
  const { values, errors, submitCount, setFieldError, setFieldValue } =
    useFormikContext<FormValues>();
  const { clinicsList } = useSelector((state: RootState) => state.clinics);

  const clinicsOptions = useMemo(() => {
    return clinicsList?.map((item) => ({
      value: item.title,
      key: item.id,
    }));
  }, [clinicsList]);

  const handleFieldChange = (option: any) => {
    if (errors.clinic && submitCount > 0) {
      setFieldError('clinic', '');
    }
    setFieldValue('clinic', option);
  };

  const onMeetingLinkChange = (newValue: string) => {
    setFieldValue('meeting_link', newValue);
    setFieldError('meeting_link', '');
  };

  return (
    <div className='location-container'>
      <div className='section-title'>Type</div>
      <div
        className={`location-btns-wrapper${isAppointmentView ? ' location-btns-wrapper--disabled' : ''
          }`}
      >
        <LocationButtons
          onLocationBtnClick={onLocationBtnClick}
          currentLocationOption={currentLocationOption}
          membershipType={membershipType}
          isAppointmentView={isAppointmentView}
        />
      </div>

      {currentLocationOption === LocationType.CLINIC && (
        <Select
          name='clinic'
          placeholder='Choose clinic *'
          onChange={handleFieldChange}
          options={clinicsOptions!}
          selectedOption={values.clinic}
          isError={false}
          isDisable={isAppointmentView}
        />
      )}

      {(currentLocationOption === LocationType.HISTORICRESULTS ||
        currentLocationOption === LocationType.DEXA) && (
          <>
            <p style={{ marginBottom: "10px" }}>Clinic Address (optional)</p>
            <Select
              name='clinic'
              placeholder='Choose address'
              onChange={handleFieldChange}
              options={clinicsOptions!}
              selectedOption={values.clinic}
              isError={false}
              isDisable={isAppointmentView}
            />
          </>
        )}
      {currentLocationOption === LocationType.SCAN && (
        <>
          <p style={{ marginBottom: "10px" }}>Clinic Address *</p>
          <Select
            name='clinic'
            placeholder='Choose clinic address *'
            onChange={handleFieldChange}
            options={clinicsOptions!}
            selectedOption={values.clinic}
            isError={false}
            isDisable={isAppointmentView}
          />
        </>
      )}
      {currentLocationOption === LocationType.MEMBER_HOME && (
        <></>
      )}
      {currentLocationOption === LocationType.ONLINE && (
        <TextInput
          name='meeting_link'
          placeholder='Enter meeting link'
          type='text'
          onChange={(e) => onMeetingLinkChange(e.target.value)}
          value={values.meeting_link ?? ''}
          isError={!!errors.meeting_link}
          errorMessage={errors.meeting_link}
          isDisabled={isAppointmentView}
        />
      )}
    </div>
  );
};

export default AppointmentLocation;
